<template>
    <ModalShell :title="title" :subtitle="body" width="sm:max-w-[480px] sm:w-full w-11/12">
        <template #icon>
            <PhLockKey :size="24" weight="regular" class="text-zinc-700" />
        </template>
        <template #footer>
            <PrimeButton class="p-btn-root_secondary" label="Maybe later" @click="closeDialog" />
            <PrimeButton :label="ctaLabel" @click="primary" />
        </template>
    </ModalShell>
</template>

<script setup lang="ts">
import { PhLockKey } from '@phosphor-icons/vue';
import { getDialogRef } from '~/composables/dynamic-dialog';
import ModalShell from '~/components/modals/shared/ModalShell.vue';
import { ModalNames } from '~/types/modals';

const dialogRef = getDialogRef(ModalNames.FEATURE_LOCKED);
const feature = computed(() => dialogRef.value.data.feature);

// The gates that open this modal are keyed off the selected/loaded person (impersonation-aware), so
// the offer is about that person's licence — not the authenticated buyer's.
const { hasActiveLicense, gate, promptForGate } = useLicenseAccess();

const title = computed(() =>
    hasActiveLicense.value ? `Upgrade your license to activate ${feature.value}` : `${feature.value} requires a license`
);

const body = computed(() =>
    hasActiveLicense.value
        ? 'Modify your plan to include this feature — proration is calculated at secure checkout.'
        : 'See plans that include this feature on our pricing page.'
);

const ctaLabel = computed(() => (hasActiveLicense.value ? 'Modify License' : 'See Plans'));

function closeDialog() {
    dialogRef.value.close();
}

function primary() {
    // Through the shared gate: the employer purchase-restriction guard applies, and the loaded
    // (impersonation-aware) person is both the subject of the gate and the beneficiary — never the
    // authenticated buyer. A live seat that does not reach this feature is the upgrade case; with
    // no live seat the gate chooses between assigning a spare one and selling one.
    promptForGate(hasActiveLicense.value ? 'needs_upgrade' : gate.value);
    closeDialog();
}
</script>
